export const INDUSTRY_OPTIONS = [
  'Accounting',
  'Advertising & Marketing',
  'Aerospace & Defense',
  'Agriculture',
  'Architecture & Planning',
  'Art & Design',
  'Automotive',
  'Banking',
  'Biotechnology',
  'Building Materials',
  'Business Consulting',
  'Cannabis',
  'Capital Markets',
  'Chemicals',
  'Civic & Social Organizations',
  'Civil Engineering',
  'Commercial Real Estate',
  'Computer Hardware',
  'Computer Networking',
  'Construction',
  'Consumer Electronics',
  'Consumer Goods',
  'Consumer Services',
  'Cosmetics',
  'Cybersecurity',
  'Defense Technology',
  'Dentistry',
  'Design Services',
  'E-commerce',
  'Education',
  'Electrical & Electronic Manufacturing',
  'Energy',
  'Engineering Services',
  'Entertainment',
  'Environmental Services',
  'Events Services',
  'Fashion & Apparel',
  'Financial Services',
  'Fine Art',
  'Food & Beverage',
  'Food Production',
  'Fundraising',
  'Furniture',
  'Government Administration',
  'Graphic Design',
  'Health & Wellness',
  'Higher Education',
  'Hospital & Health Care',
  'Hospitality',
  'Human Resources',
  'Industrial Automation',
  'Industrial Manufacturing',
  'Information Technology',
  'Insurance',
  'Interior Design',
  'Investment Management',
  'Law Practice',
  'Legal Services',
  'Logistics & Supply Chain',
  'Luxury Goods & Jewelry',
  'Machinery',
  'Management Consulting',
  'Marine',
  'Media Production',
  'Medical Devices',
  'Mental Health Care',
  'Mining & Metals',
  'Motion Pictures & Film',
  'Museums & Institutions',
  'Music',
  'Nonprofit Organization Management',
  'Oil & Gas',
  'Online Media',
  'Pharmaceuticals',
  'Photography',
  'Professional Training & Coaching',
  'Property Management',
  'Public Relations & Communications',
  'Publishing',
  'Real Estate',
  'Recreational Facilities & Services',
  'Religious Institutions',
  'Renewables & Environment',
  'Restaurants',
  'Retail',
  'SaaS',
  'Security & Investigations',
  'Semiconductors',
  'Shipping',
  'Software Development',
  'Sporting Goods',
  'Sports',
  'Staffing & Recruiting',
  'Telecommunications',
  'Textiles',
  'Transportation',
  'Travel & Tourism',
  'Utilities',
  'Venture Capital & Private Equity',
  'Veterinary',
  'Warehousing',
  'Wholesale',
  'Wine & Spirits',
] as const;

export type IndustryOption = (typeof INDUSTRY_OPTIONS)[number];
